// Configuración de avatares estáticos estilo DALL-E
// Avatares organizados por carpetas boys y girls

export const AVATAR_CATEGORIES = {
  girls: {
    label: 'Femenino',
    description: 'Avatares con estilo femenino',
  },
  boys: {
    label: 'Masculino',
    description: 'Avatares con estilo masculino',
  }
};

// Lista de avatares disponibles desde las carpetas boys y girls
export const AVATAR_PRESETS = [
  // Categoría: Girls
  { id: 'girl-1', category: 'girls', folder: 'girls', file: 'OIG.jpeg', label: 'Avatar Femenino 1' },
  { id: 'girl-2', category: 'girls', folder: 'girls', file: 'OIG (1).jpeg', label: 'Avatar Femenino 2' },
  { id: 'girl-3', category: 'girls', folder: 'girls', file: 'OIG (2).jpeg', label: 'Avatar Femenino 3' },
  { id: 'girl-4', category: 'girls', folder: 'girls', file: 'OIG (3).jpeg', label: 'Avatar Femenino 4' },
  { id: 'girl-5', category: 'girls', folder: 'girls', file: 'OIG (4).jpeg', label: 'Avatar Femenino 5' },
  { id: 'girl-6', category: 'girls', folder: 'girls', file: 'OIG (5).jpeg', label: 'Avatar Femenino 6' },
  { id: 'girl-7', category: 'girls', folder: 'girls', file: 'OIG (6).jpeg', label: 'Avatar Femenino 7' },
  { id: 'girl-8', category: 'girls', folder: 'girls', file: 'OIG (7).jpeg', label: 'Avatar Femenino 8' },
  { id: 'girl-9', category: 'girls', folder: 'girls', file: 'OIG.4bpJFM98VAPg.jpeg', label: 'Avatar Femenino 9' },
  { id: 'girl-10', category: 'girls', folder: 'girls', file: 'OIG.HO6tQxApN.jpeg', label: 'Avatar Femenino 10' },
  { id: 'girl-11', category: 'girls', folder: 'girls', file: 'OIG.rf.jpeg', label: 'Avatar Femenino 11' },
  
  // Categoría: Boys
  { id: 'boy-1', category: 'boys', folder: 'boys', file: 'OIG.jpeg', label: 'Avatar Masculino 1' },
  { id: 'boy-2', category: 'boys', folder: 'boys', file: 'OIG (1).jpeg', label: 'Avatar Masculino 2' },
  { id: 'boy-3', category: 'boys', folder: 'boys', file: 'OIG (2).jpeg', label: 'Avatar Masculino 3' },
  { id: 'boy-4', category: 'boys', folder: 'boys', file: 'OIG (3).jpeg', label: 'Avatar Masculino 4' },
  { id: 'boy-5', category: 'boys', folder: 'boys', file: 'OIG (4).jpeg', label: 'Avatar Masculino 5' },
  { id: 'boy-6', category: 'boys', folder: 'boys', file: 'OIG..9wT0oT4grRDhsR.jpeg', label: 'Avatar Masculino 6' },
  { id: 'boy-7', category: 'boys', folder: 'boys', file: 'OIG.AUoA6dyHDlbL6fZw2.jpeg', label: 'Avatar Masculino 7' },
  { id: 'boy-8', category: 'boys', folder: 'boys', file: 'OIG.ou8TYwx54.jpeg', label: 'Avatar Masculino 8' },
  { id: 'boy-9', category: 'boys', folder: 'boys', file: 'OIG.TPj5bwNBoX2VQwgZ.jpeg', label: 'Avatar Masculino 9' },
];

// Paletas de colores para personalización
export const COLOR_PALETTES = {
  background: [
    { name: 'Azul', color: '#4A90E2' },
    { name: 'Púrpura', color: '#9B59B6' },
    { name: 'Verde', color: '#27AE60' },
    { name: 'Naranja', color: '#E67E22' },
    { name: 'Rosa', color: '#E91E63' },
    { name: 'Turquesa', color: '#1ABC9C' },
    { name: 'Rojo', color: '#E74C3C' },
    { name: 'Gris', color: '#95A5A6' },
  ],
  border: [
    { name: 'Dorado', color: '#F39C12' },
    { name: 'Plata', color: '#BDC3C7' },
    { name: 'Negro', color: '#2C3E50' },
    { name: 'Blanco', color: '#ECF0F1' },
  ]
};

// Filtros de imagen que se pueden aplicar
export const IMAGE_FILTERS = {
  none: { name: 'Normal', css: '' },
  warm: { name: 'Cálido', css: 'sepia(30%) saturate(120%)' },
  cool: { name: 'Frío', css: 'hue-rotate(180deg) saturate(110%)' },
  vibrant: { name: 'Vibrante', css: 'saturate(150%) contrast(110%)' },
  soft: { name: 'Suave', css: 'brightness(105%) contrast(90%)' },
  vintage: { name: 'Vintage', css: 'sepia(50%) contrast(85%)' },
  dramatic: { name: 'Dramático', css: 'contrast(130%) brightness(95%)' },
};

// Función para obtener la URL del avatar
export const getAvatarUrl = (avatarId) => {
  const preset = AVATAR_PRESETS.find(p => p.id === avatarId);
  if (!preset) return '/avatars/girls/OIG.jpeg';
  return `/avatars/${preset.folder}/${preset.file}`;
};

// Función para obtener avatar aleatorio
export const getRandomAvatar = () => {
  const randomIndex = Math.floor(Math.random() * AVATAR_PRESETS.length);
  return AVATAR_PRESETS[randomIndex];
};

// Función para aplicar personalización al avatar
export const applyAvatarCustomization = (avatarId, customization) => {
  return {
    avatarId,
    backgroundColor: customization.backgroundColor || COLOR_PALETTES.background[0].color,
    borderColor: customization.borderColor || 'transparent',
    filter: customization.filter || 'none',
    borderWidth: customization.borderWidth || 0,
  };
};

export default {
  AVATAR_CATEGORIES,
  AVATAR_PRESETS,
  COLOR_PALETTES,
  IMAGE_FILTERS,
  getAvatarUrl,
  getRandomAvatar,
  applyAvatarCustomization,
};
